import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { HomeService } from "../../../services";
import { useDispatch } from "react-redux";
import { alertActions } from "../../../actions";
import { useSelector } from "react-redux";
import { StandardService } from "../../../services";
import { MyAccountService } from "../../../services";
import { BookingDetailsService } from "../../../services/BookingDetailsService";

const useHome = (location, t) => {
  const [roomList, setRoomList] = useState([]);
  const [notAvailable, setNotAvailable] = useState([]);
  const [initialRoom, setInitialRoom] = useState(false);
  const [selectedRoomCount, setSelectedRoomCount] = useState("");
  const [selectedAdultCount, setSelectedAdultCount] = useState("");
  const [selectedChildrenCount, setSelectedChildrenCount] = useState("");
  const [loader, setLoader] = useState("notset");
  const [singleRoomDetail, setSingleRoomDetail] = useState("");
  const user_id = useSelector((state) => state?.userData?.user?._id);
  const user_name = useSelector((state) => state?.userData?.user?.name);
  const user_email = useSelector((state) => state?.userData?.user?.email);
  const user_phone = useSelector((state) => state?.userData?.user?.phone);
  const [removeRooms, setRemoveRooms] = useState(false);
  const [adultcount, setAdultcount] = useState("");
  const [roomsDatassss, setRoomsDatassss] = useState([]);
  const [addedPersons, setAddedPersons] = useState(0);
  const [cartData, setCartData] = useState("");
  const [cartId, setCartId] = useState("");
  const [differenceDate, setDifferenceDate] = useState("");
  const [childAgeSelected, setChildAgeSelected] = useState(false);
  const [childrenCount, setChildrenCount] = useState("");
  const [childrenAges, setChildrenAges] = useState([]);
  const [modalRenderTrigger, setModalRenderTrigger] = useState(false);
  const [updateClicked, setUpdateClicked] = useState(false);
  const AdultCountLoc = localStorage.getItem("AdultCount");
  const RoomCountLoc = localStorage.getItem("RoomCount");
  const ChildrenCountLoc = localStorage.getItem("ChildrenCount");
  const [extractedData, setExtractedData] = useState([]);
  const [editIndex, setEditIndex] = useState();
  const [tempAdultCount, setTempAdultCount] = useState();
  const [tempRoomCount, setTempRoomCount] = useState();
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [dateSelection, setDateSelection] = useState(true);
  const [selectAdultEdit, setSelectAdultEdit] = useState(0);
  const [childArrayAge, setChildAgeArray] = useState([]);
  const [refreshClickked, setRefreshClicked] = useState(false);
  const [nutralCheckIn, setNutralChein] = useState(
    localStorage.getItem("datetime1")
  );
  const [nutralCheckOut, setNutralCheOut] = useState(
    localStorage.getItem("datetime2")
  );
  const [datetimeIn, setdatetimeIn] = useState(
    localStorage.getItem("datetimeIn")
  );
  const [datetimeOut, setdatetimeOut] = useState(
    localStorage.getItem("datetimeOut")
  );
  const [selectChildrenEdit, setSelectChildrenEdit] = useState(0);
  const [adultLengthDisplay, setAdultLengthDisplay] = useState(0);
  const [childrenLengthDisplay, setChildrenLengthDisplay] = useState(0);

  useEffect(() => {
    setChildrenAges([]);
  }, [childArrayAge]);

  const AddRoomCart = async (data) => {
    setAdultLengthDisplay(0);
    setChildrenLengthDisplay(0);
    try {
      setLoader("loading");
      const response = await HomeService.checkRoom(
        RoomCountLoc,
        AdultCountLoc,
        ChildrenCountLoc,
        false,
        childArrayAge ? childArrayAge : []
      );
      if (response.data.status.code == 0) {
        // navigate(`/cart-page`);

        setAdultcount(1);
        setUpdateClicked(false);
        if (user_id) {
          // Extract Room Type IDs
          const extractedIds = cartData?.rooms
            .filter(
              (_, index) =>
                index %
                  calculateDifference(
                    cartData?.arrival_date,
                    cartData?.departure_date
                  ) ===
                0
            )
            .map((item) => item.roomTypeId);

          if (extractedIds?.length > 0) {
            let currentCount =
              extractedIds.filter((id) => id === data._id).length || 0;

            if (currentCount < data.available_rooms) {
              setRemoveRooms(true);
            } else {
              dispatch(
                alertActions.error(
                  `You've reached the limit of ${data.available_rooms} rooms. Please select a different room type.`
                )
              );
            }
          } else {
            setRemoveRooms(true);
          }
          setSingleRoomDetail(data);
        } else {
          dispatch(alertActions.success("Please login to continue"));
          navigate("/login");
        }
      } else {
        dispatch(alertActions.error(response.data.status.message));
      }
    } catch (error) {
      dispatch(alertActions.error(t(error)));
      console.log("error", error);
    } finally {
      setLoader("isFull");
    }
  };

  const updateRoom = () => {
    if (childrenCount == childrenAges?.length || childrenCount == 0) {
      setChildAgeSelected(false);
      setExtractedData((prevData) => {
        const updatedData = prevData.map((item, index) => {
          if (
            index >= editIndex * differenceDate &&
            index < (editIndex + 1) * differenceDate
          ) {
            return {
              ...item,
              adultcount: item.actualAdultCount,
              childrenAges: childrenAges,
              adults: adultcount,
              infants: childrenAges,
            };
          } else {
            // Update all other items
            return {
              ...item,
              adults: Number(item.actualAdultCount),
            };
          }
        });

        BookingDetailsService.updateCartRooms(updatedData)
          .then((res) => {
            if (res?.data?.status?.code === 0) {
              setRemoveRooms(false);
              setLoader("isfull");
              MyAccountService.getCartItems(user_id, 1)
                .then((res) => {
                  if (res?.data?.status?.code === 0) {
                    setCartData(res?.data?.data[0]);
                    setCartId(res?.data?.data[0]?.cartId);

                    setDifferenceDate(
                      calculateDifference(
                        res?.data?.data[0]?.arrival_date,
                        res?.data?.data[0]?.departure_date
                      )
                    );

                    setRoomsDatassss(res?.data?.data[0]?.rooms || []);
                    setTempRoomCount((prev) => prev - 1);
                    setTempAdultCount((prev) => prev - adultcount);
                    setSelectedChildrenCount((prev) => prev - childrenCount);
                    setLoader("isfull");
                  }
                })
                .catch((error) => {
                  setLoader("isfull");
                  console.log("Errorreg", error);
                  dispatch(alertActions.error(error));
                });
              dispatch(alertActions.success(res.data.status.message));
            } else {
              setLoader("isempty");
              dispatch(alertActions.error(res.data.status.message));
            }
          })
          .catch((error) => {
            console.log("Errorreg", error);
          });
        return updatedData;
      });
    } else {
      setChildAgeSelected(true);
    }
  };

  const closeModal = () => {
    setRemoveRooms(false);
  };

  const closeModalEdit = (selectAdultEdit, selectChildrenEdit) => {
    setRemoveRooms(false);
    setTempRoomCount((prev) => prev - 1);
    setTempAdultCount((prev) => prev - selectAdultEdit);
    setSelectedChildrenCount((prev) => prev - selectChildrenEdit);
    setChildrenCount((prev) => prev - selectChildrenEdit);
    setSelectAdultEdit(0);
    setSelectChildrenEdit(0);
  };

  const handleChangeAdult = (e) => {
    setAdultcount(e.target.value);
  };

  const handleChange = (e) => {
    setChildrenAges([]);
    setChildrenCount(parseInt(e.target.value, 10)); // Convert to number
    setModalRenderTrigger((prev) => !prev);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  var dataPath = "";
  localStorage.removeItem("service");
  localStorage.removeItem("service1");
  localStorage.removeItem("adult");
  localStorage.removeItem("amountdata1");
  localStorage.removeItem("id");
  localStorage.removeItem("rooms");
  localStorage.removeItem("children");
  localStorage.removeItem("amountdata");

  localStorage.removeItem("rzp_device_id");
  useEffect(() => {
    localStorage.removeItem("datetimes");
    localStorage.removeItem("datetimes1");
    setSelectedAdultCount(localStorage.getItem("AdultCount"));
    setSelectedRoomCount(localStorage.getItem("RoomCount"));
    setChildrenCount(localStorage.getItem("ChildrenCount"));
    setChildrenAges(localStorage.getItem("ChildrenAges"));
    setChildAgeArray(localStorage.getItem("ChildrenAgesArray"));

    // if (localStorage.getItem("RoomCount")) {
    HomeService.roomlist()
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setRoomList(res?.data?.data?.rooms);
          setLoader("isfull");
          setInitialRoom(true);
          localStorage.setItem("datetimes", null);
          localStorage.setItem("datetimes1", null);
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
    // }
    if (user_id) {
      MyAccountService.getCartItems(user_id, 1)
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setCartData(res?.data?.data[0]);
            setCartId(res?.data?.data[0]?.cartId);
            setTempAdultCount(0);
            setTempRoomCount(0);
            setSelectedChildrenCount(0);

            setDifferenceDate(
              calculateDifference(
                res?.data?.data[0]?.arrival_date,
                res?.data?.data[0]?.departure_date
              )
            );

            if (
              startTime == res?.data?.data[0]?.arrival_date &&
              endTime == res?.data?.data[0]?.departure_date
            ) {
              setRoomsDatassss(res?.data?.data[0]?.rooms || []);
            }

            setLoader("isfull");
          }
        })
        .catch((error) => {
          setLoader("isfull");
          console.log("Errorreg", error);
          dispatch(alertActions.error(error));
        });
    }
  }, []);

  // Periodically check `localStorage` for changes
  useEffect(() => {
    const intervalId = setInterval(() => {
      // Check if `localStorage` values have changed
      const updatedDatetime1 = localStorage.getItem("datetime1");
      const updatedDatetime2 = localStorage.getItem("datetime2");

      // If values have changed, update the state
      if (updatedDatetime1 !== nutralCheckIn) {
        setNutralChein(updatedDatetime1);
      }
      if (updatedDatetime2 !== nutralCheckOut) {
        setNutralCheOut(updatedDatetime2);
      }
    }, 1000); // Check every second (adjust as needed)

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [nutralCheckIn, nutralCheckOut]); // Ensure we track changes to these values

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("datetimes1");
      localStorage.removeItem("RoomCount");
      localStorage.removeItem("AdultCount");
      localStorage.removeItem("ChildrenCount");
      localStorage.removeItem("ChildrenAges");
      localStorage.removeItem("ChildrenAgesArray");
      localStorage.removeItem("datetime1");
      localStorage.removeItem("datetime2");
      localStorage.removeItem("ChildrenAgesArray");
      localStorage.removeItem("datetimeIn");
      localStorage.removeItem("datetimeOut");

      setTempAdultCount(0);
      setTempRoomCount(0);
      setStartTime("");
      setEndTime("");
      setRefreshClicked(true);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const convertDateFormat = (dateString) => {
    if (!dateString) return "N/A"; // Handle missing data

    const dateParts = dateString.split(" "); // Split the string into parts
    if (dateParts.length < 5) return "Invalid Date"; // Ensure format is correct

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = dateParts[2];
    const month = (monthNames.indexOf(dateParts[1]) + 1)
      .toString()
      .padStart(2, "0"); // Convert month to number
    const year = dateParts[3];

    return `${year}-${month}-${day}`;
  };

  /**
   * get room list
   */
  useEffect(() => {
    if (
      localStorage?.getItem("datetime1") !== null &&
      localStorage?.getItem("datetime2") !== null
    ) {
      setStartTime(convertDateFormat(localStorage?.getItem("datetime1")));
      setEndTime(convertDateFormat(localStorage?.getItem("datetime2")));
    }
    setSelectedRoomCount(localStorage.getItem("RoomCount"));
    setSelectedAdultCount(localStorage.getItem("AdultCount"));
    setSelectedChildrenCount(localStorage.getItem("ChildrenCount"));
    setChildAgeArray(localStorage.getItem("ChildrenAgesArray"));
    setChildrenAges(
      localStorage.getItem("ChildrenAges")?.split(",").map(Number)
    );
    setChildrenCount(
      localStorage.getItem("ChildrenCount") < 2
        ? localStorage.getItem("ChildrenCount")
        : 2
    );
    if (user_id) {
      MyAccountService.getCartItems(user_id, 1)
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setCartData(res?.data?.data[0]);
            setCartId(res?.data?.data[0]?.cartId);
            setChildrenCount(0);
            setChildrenAges(0);
            setDifferenceDate(
              calculateDifference(
                res?.data?.data[0]?.arrival_date,
                res?.data?.data[0]?.departure_date
              )
            );

            if (
              startTime == res?.data?.data[0]?.arrival_date &&
              endTime == res?.data?.data[0]?.departure_date
            ) {
              setRoomsDatassss(res?.data?.data[0]?.rooms || []);
            }
            setLoader("isfull");
          }
        })
        .catch((error) => {
          setLoader("isfull");
          console.log("Errorreg", error);
          dispatch(alertActions.error(error));
        });
    }

    if (
      new Date(location?.state?.checkindate) >=
        new Date(location?.state?.checkoutdate) &&
      !selectedAdultCount &&
      !selectedRoomCount
    ) {
      dispatch(alertActions.error(t("Checkin_and_Checkout_Date_is_Invalid")));
    } else {
      if (nutralCheckIn && nutralCheckOut) {
        setLoader("loading");

        HomeService.getRoomList(
          datetimeIn
            ? new Date(
                new Date(datetimeIn).setDate(new Date(datetimeIn).getDate() + 1)
              )
                .toISOString()
                .split("T")[0]
            : location?.state?.checkindate,
          datetimeOut
            ? new Date(
                new Date(datetimeOut).setDate(
                  new Date(datetimeOut).getDate() + 1
                )
              )
                .toISOString()
                .split("T")[0]
            : location?.state?.checkoutdate,
          selectedAdultCount,
          selectedRoomCount,
          localStorage.getItem("ChildrenAgesArray") || ""
          // childArrayAge ? childArrayAge : []
        )
          .then((res) => {
            if (res?.data?.status?.code === 0) {
              setInitialRoom(false);

              setRoomList(res?.data?.data[0]?.roomTypeDetails);
              setNotAvailable(res?.data?.data[0]?.nonAvailableRooms);
              setLoader("isfull");
              if (res?.data?.status?.message !== "rooms-list") {
                return;
                dispatch(alertActions.success(res?.data?.status?.message));
              }
            } else {
              setRoomList("");
            }
          })
          .catch((error) => {
            setRoomList("");
            console.log("Errorreg", error);
          });
      }
    }
  }, [
    location?.state?.id,
    location,
    startTime,
    selectedAdultCount,
    selectedRoomCount,
  ]);

  useEffect(() => {
    if (cartData) {
      const bookingIds = cartData?.rooms.map((item) => item.bookingId);

      MyAccountService.deleteCartBooking(bookingIds, cartData?.cartId)
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setRemoveRooms(false);
            setCartData("");
            setTempAdultCount(localStorage.getItem("AdultCount"));
            setTempRoomCount(localStorage.getItem("RoomCount"));
            MyAccountService.getCartItems(user_id, 1)
              .then((res) => {
                if (res?.data?.status?.code === 0) {
                  setCartData(res?.data?.data[0]);
                  setCartId(res?.data?.data[0]?.cartId);

                  setDifferenceDate(
                    calculateDifference(
                      res?.data?.data[0]?.arrival_date,
                      res?.data?.data[0]?.departure_date
                    )
                  );
                  setChildrenAges(
                    Array.isArray(childrenAges) ? childrenAges.slice(2) : [] // Removes the first two items and keeps the rest
                  );

                  setSelectedChildrenCount((prev) => prev - childrenCount);
                  setChildrenCount(0);
                  setRoomsDatassss(res?.data?.data[0]?.rooms || []);
                  setTempAdultCount(tempAdultCount - adultcount);
                  setTempRoomCount(tempRoomCount - 1);

                  setLoader("isfull");
                }
              })
              .catch((error) => {
                setLoader("isfull");
                console.log("Errorreg", error);
                dispatch(alertActions.error(error));
              });
          } else {
            setLoader("isfull");
            setRemoveRooms(false);
          }
        })
        .catch((error) => {
          setLoader("isfull");
          setRemoveRooms(false);
          console.log("Errorreg", error);
        });
    }
  }, [nutralCheckIn, nutralCheckOut]);

  const selectRoom = (data, roomsavailable) => {
    if (
      new Date(location?.state?.checkindate) >=
      new Date(location?.state?.checkoutdate)
    ) {
      dispatch(alertActions.error(t("Checkin_and_Checkout_Date_is_Invalid")));
    } else {
      if (
        localStorage.getItem("datetimes") &&
        localStorage.getItem("datetimes1")
      ) {
        localStorage.removeItem("datetimes");
        localStorage.removeItem("datetimes1");
        localStorage.removeItem("adult");
        localStorage.removeItem("children");
        localStorage.removeItem("rooms");
        localStorage.removeItem("amountdata1");
        localStorage.removeItem("amountdata");
        localStorage.removeItem("service");
        localStorage.removeItem("service1");
        localStorage.removeItem("datetimeIn");
        localStorage.removeItem("datetimeOut");
        navigate(`/standard?id=${data}`, {
          state: {
            id: data,
            loc: location?.state?.loc,
            roomsavailable: roomsavailable,
          },
        });
      } else {
        dispatch(
          alertActions.error(t("Please enter Check-in and Check-out date"))
        );
      }
    }
  };

  const proceedBtn = async (proceed) => {
    try {
      setLoader("loading");
      const response = await HomeService.checkRoom(
        RoomCountLoc,
        AdultCountLoc,
        ChildrenCountLoc,
        proceed,
        childArrayAge ? childArrayAge : []
      );
      if (response.data.status.code == 0) {
        navigate(`/cart-page`);
      } else {
        dispatch(alertActions.error(response.data.status.message));
      }
    } catch (error) {
      dispatch(alertActions.error(t(error)));
      console.log("error", error);
    } finally {
      setLoader("isFull");
    }
  };

  const addRoom = () => {
    const actualValues = (
      Array.isArray(childrenAges)
        ? childrenAges
        : typeof childrenAges === "string"
        ? childrenAges.split("").map(Number)
        : []
    ) // Default to an empty array if it's neither string nor array
      .filter((item) => item !== undefined)
      .slice(0, 2);
    if (childrenCount == actualValues?.length || childrenCount == 0) {
      setChildAgeSelected(false);
      var bookingDetails = [
        {
          adults: Number(adultcount ? adultcount : 1),
          infantAge: childrenCount > 0 ? actualValues : [],
        },
      ];
      StandardService.bookingInCartUpdated(
        datetimeIn
          ? new Date(
              new Date(datetimeIn).setDate(new Date(datetimeIn).getDate() + 1)
            )
              .toISOString()
              .split("T")[0]
          : location?.state?.checkindate,
        datetimeOut
          ? new Date(
              new Date(datetimeOut).setDate(new Date(datetimeOut).getDate() + 1)
            )
              .toISOString()
              .split("T")[0]
          : location?.state?.checkoutdate,
        singleRoomDetail.no_of_occupancy,
        singleRoomDetail.no_of_infants,
        user_name,
        user_email,
        user_phone,
        singleRoomDetail._id,
        1,
        singleRoomDetail.price,
        bookingDetails
      )
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            dataPath = res?.data?.data?.[0]?._id;
            const ids = res?.data?.data?.map((item) => item._id) || [];

            if (user_id) {
              StandardService.addToCart(user_id, ids)
                .then((res) => {
                  if (res?.data?.status?.code === 0) {
                    dispatch(alertActions.success(res?.data?.status?.message));
                    if (user_id) {
                      MyAccountService.getCartItems(user_id, 1)
                        .then((res) => {
                          if (res?.data?.status?.code === 0) {
                            setCartData(res?.data?.data[0]);
                            setCartId(res?.data?.data[0]?.cartId);

                            setDifferenceDate(
                              calculateDifference(
                                res?.data?.data[0]?.arrival_date,
                                res?.data?.data[0]?.departure_date
                              )
                            );
                            setChildrenAges(
                              Array.isArray(childrenAges)
                                ? childrenAges.slice(2)
                                : [] // Removes the first two items and keeps the rest
                            );

                            setSelectedChildrenCount(
                              (prev) => prev - childrenCount
                            );
                            setChildrenCount(0);
                            setRoomsDatassss(res?.data?.data[0]?.rooms || []);
                            setTempAdultCount(tempAdultCount - adultcount);
                            setTempRoomCount(tempRoomCount - 1);

                            setLoader("isfull");
                          }
                        })
                        .catch((error) => {
                          setLoader("isfull");
                          console.log("Errorreg", error);
                          dispatch(alertActions.error(error));
                        });
                    }

                    setRemoveRooms(false);
                    setLoader("isfull");
                  } else {
                    dispatch(alertActions.error(res?.data?.status?.message));

                    setRemoveRooms(false);
                    setLoader("isfull");
                  }
                })
                .catch((err) => console.log(err));
            } else {
              localStorage.setItem("cartNotLoggedIn", ids);
              navigate("/");
            }
          } else {
            dispatch(alertActions.error(res?.data?.status?.message));
            setRemoveRooms(false);
            setLoader("isfull");
          }
        })
        .catch((err) => console.log(err));
    } else {
      setChildAgeSelected(true);
    }
  };

  const editDetails = (roomsss, index, room) => {
    setUpdateClicked(true);
    setEditIndex(index);
    setAdultLengthDisplay(room.actualAdultCount);
    setChildrenLengthDisplay(room.infants.length);
    setTempRoomCount((prev) => prev + 1);
    setTempAdultCount(
      (prev) => prev + roomsss[index * differenceDate].actualAdultCount
    );
    setSelectAdultEdit(roomsss[index * differenceDate].actualAdultCount);
    setSelectedChildrenCount(
      (prev) => prev + roomsss[index * differenceDate].infants.length
    );
    setChildrenCount(roomsss[index * differenceDate].infants.length);
    setSelectChildrenEdit(roomsss[index * differenceDate].infants.length);

    setRemoveRooms(true);
    setAdultcount(room?.actualAdultCount);
    setChildrenCount(room?.infants?.length);
    if (
      room?.infants?.every((age) => childArrayAge?.includes(age)) // Check if all room.infants exist in childArrayAge
    ) {
      setChildrenAges(room?.infants); // Assign if both are exactly the same
    } else {
      setChildrenAges([]); // Assign empty array if elements do not match
    }

    // setChildrenAges(room?.infants);

    const adultsArray = roomsss
      ?.filter((room) => room.roomTypeId === room.roomTypeId)
      ?.map((filteredRoom) => filteredRoom.actualAdultCount);

    const filteredArray = adultsArray?.filter(
      (_, index) => index % differenceDate === 0
    );

    const childrenArray = roomsss
      ?.filter((room) => room.roomTypeId === room.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infants?.length);

    const filteredArray1 = childrenArray?.filter(
      (_, index) => index % differenceDate === 0
    );

    const childrenArrayAbove = roomsss
      ?.filter((room) => room.roomTypeId === room.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infantsAbove8?.length);

    const filteredArray2 = childrenArrayAbove?.filter(
      (_, index) => index % differenceDate === 0
    );

    setExtractedData(
      cartData?.rooms?.map(
        ({
          adults,
          bookingId,
          roomTypeId,
          room_type,
          infantsUnder8,
          infantsAbove8,
          infants,
          actualAdultCount,
          no_of_occupancy,
          no_of_infants,
        }) => ({
          adults,
          bookingId,
          roomTypeId,
          room_type,
          infantsUnder8,
          infantsAbove8,
          infants,
          actualAdultCount,

          no_of_occupancy,
          no_of_infants,
        })
      )
    );
  };

  const handleChildAgeChange = (index, event) => {
    setChildAgeSelected(false);
    const newAges = [...childrenAges];
    newAges[index] = parseInt(event.target.value, 10);
    setChildrenAges(newAges);
  };

  const deleteRoom = (room, index) => {
    const startIndex = index * differenceDate;
    const endIndex = startIndex + differenceDate;
    const bookingIds = room
      .slice(startIndex, endIndex)
      .map((item) => item.bookingId);
    MyAccountService.deleteCartBooking(bookingIds, cartId)
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setTempRoomCount((prev) => prev + 1);
          setTempAdultCount(
            tempAdultCount + room[index * differenceDate].actualAdultCount
          );
          setSelectedChildrenCount(
            (prev) => prev + room[index * differenceDate].infants.length
          );
          setRemoveRooms(false);
          dispatch(alertActions.success(res?.data?.status?.message));
          if (user_id) {
            MyAccountService.getCartItems(user_id, 1)
              .then((res) => {
                if (res?.data?.status?.code === 0) {
                  setCartData(res?.data?.data[0]);
                  setCartId(res?.data?.data[0]?.cartId);

                  setDifferenceDate(
                    calculateDifference(
                      res?.data?.data[0]?.arrival_date,
                      res?.data?.data[0]?.departure_date
                    )
                  );
                  setRoomsDatassss(res?.data?.data[0]?.rooms || []);
                  setLoader("isfull");
                }
              })
              .catch((error) => {
                setLoader("isfull");
                console.log("Errorreg", error);
                dispatch(alertActions.error(error));
              });
          }
        } else {
          setLoader("isfull");
          setRemoveRooms(false);
          dispatch(alertActions.error(res?.data?.status?.message));
        }
      })
      .catch((error) => {
        setLoader("isfull");
        setRemoveRooms(false);
        console.log("Errorreg", error);
      });
  };

  const calculateDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = end - start;
    return diffTime / (1000 * 60 * 60 * 24);
  };

  useEffect(() => {
    if (roomsDatassss?.length) {
      const totalAdults = roomsDatassss.reduce(
        (sum, item) => sum + item.actualAdultCount / differenceDate,
        0
      );
      const totalChildren = roomsDatassss.reduce(
        (sum, item) => sum + item.infants.length / differenceDate,
        0
      );
      setTempRoomCount(
        Number(RoomCountLoc) - roomsDatassss?.length / differenceDate
      );

      setTempAdultCount(
        Number(AdultCountLoc) - Number(Math.round(totalAdults))
      );
      setSelectedChildrenCount(Number(ChildrenCountLoc) - (totalChildren || 0));
    } else {
      setTempRoomCount(Number(RoomCountLoc));
      setTempAdultCount(Number(AdultCountLoc));
      setSelectedChildrenCount(0);
    }
  }, [RoomCountLoc, AdultCountLoc, ChildrenCountLoc]);

  // console.log("RENDER roomsDatassss:", roomsDatassss);

  // useEffect(() => {
  //   console.log(roomsDatassss, "roomsDatassss");
  // }, [roomsDatassss]);

  return {
    selectRoom,
    addRoom,
    updateRoom,
    AddRoomCart,
    closeModal,
    handleChangeAdult,
    handleChange,
    proceedBtn,
    deleteRoom,
    handleChildAgeChange,
    editDetails,
    user_id,
    roomList,
    notAvailable,
    loader,
    initialRoom,
    selectedRoomCount,
    selectedAdultCount,
    selectedChildrenCount,
    singleRoomDetail,
    childrenCount,
    adultcount,
    removeRooms,
    roomsDatassss,
    addedPersons,
    differenceDate,
    childAgeSelected,
    childrenAges,
    modalRenderTrigger,
    updateClicked,
    tempAdultCount,
    tempRoomCount,
    startTime,
    endTime,
    cartData,
    selectAdultEdit,
    selectChildrenEdit,
    adultLengthDisplay,
    childrenLengthDisplay,
    childArrayAge,
    nutralCheckIn,
    nutralCheckOut,
    AdultCountLoc,
    RoomCountLoc,
    closeModalEdit,
  };
};
export default useHome;
